import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router'
import _ from 'lodash'
// import log from 'loglevel'

import config from '../../../../config'

import './style.scss'

// dynamically get Workspace components (all modules except Home)
const workspaceModules = _.map(
    _.filter(config.modules, (module) => module.key !== config.modules.home.key),
    (module) => module.key
)
const workspaceComponents = _.reduce(
    workspaceModules,
    (acc, module) => {
        let component = null
        try {
            // eslint-disable-next-line import/no-dynamic-require, global-require
            component = require(`../../scenes/${_.upperFirst(module)}/components/Workspace`).default
        } catch (error) {
            // log.warn(`Missing Workspace component ${module}`)
        }

        return {
            ...acc,
            [module]: component,
        }
    },
    {}
)

export default class Workspace extends PureComponent {
    static propTypes = {
        hasToolbar: PropTypes.bool,
    }

    routeRender = (WorkspaceComponent, moduleKey) => (props) => {
        const queryStringId = _.get(props, 'match.params.id', null)

        return (
            <WorkspaceComponent
                hasToolbar={this.props.hasToolbar}
                id={`module_${moduleKey}`}
                queryStringId={queryStringId}
            />
        )
    }

    render() {
        const routes = _.map(workspaceComponents, (WorkspaceComponent, module) => {
            if (WorkspaceComponent === null) return null

            return (
                <Switch key={module}>
                    <Route
                        path={`/${config.modules[module].route}`}
                        exact
                        render={this.routeRender(WorkspaceComponent, module)}
                    />
                    <Route
                        path={`/${config.modules[module].route}/:id`}
                        exact
                        render={this.routeRender(WorkspaceComponent, module)}
                    />
                </Switch>
            )
        })

        return <div className={'workspace'}>{routes}</div>
    }
}
